<div class="mobile-vertical-alignment-padding" *ngIf="showsBackButton || showsNextButton"></div>

<div class="footer-container">
  <div *ngIf="showFade" class="fade-container" [ngClass]="{ 'no-large-fade': !showLargeFade }"></div>
  <div
    class="container"
    [ngClass]="{ 'nav-diffHeader': showNav }"
    *ngIf="showsBackButton || showsNextButton || showsSkip || showsContent">
    <div *ngIf="!showsBackButton"></div>
    <button
      (click)="back()"
      *ngIf="showsBackButton"
      [disabled]="disableBackButton"
      class="arrow-button"
      aria-label="back"
      data-e2e="navPrevButton">
      <svg-icon src="/assets/icons/chevron-left-circle.svg"></svg-icon>
    </button>
    <div class="projected-content"><ng-content></ng-content></div>
    <button
      *ngIf="showsNextButton && !showsSkip"
      (click)="next()"
      [disabled]="disableNextButton"
      class="arrow-button"
      aria-label="continue"
      data-e2e="navNextButton">
      <svg-icon src="/assets/icons/chevron-right-circle.svg"></svg-icon>
    </button>
    <button *ngIf="showsSkip" (click)="next()" class="skip-button button button-pill button-secondary">Skip</button>
    <div *ngIf="!showsNextButton && !showsSkip"></div>
  </div>
</div>
